import React, { useState, useRef, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { AccordionItemContainer, AccordionItemItemPoorlyNamedDuplicateComponentToggle, AccordionItemItemContent } from './Item.style';
import { IAccordionItem } from '../Accordion.i';

export const AccordionItem = ({ heading, content, compact=false }: IAccordionItem) => {
  const copy = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(copy?.current?.offsetHeight || 0);
    const onResize = () => setHeight(copy?.current?.offsetHeight || 0);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [copy?.current?.offsetHeight]);

  return (
    <AccordionItemContainer>
      <AccordionItemItemPoorlyNamedDuplicateComponentToggle show={show} onPress={() => setShow(!show)} compact={compact}>
        {heading}
        <FaChevronDown />
      </AccordionItemItemPoorlyNamedDuplicateComponentToggle>
      <AccordionItemItemContent show={show} ht={height} compact={compact}>
        {typeof content !== 'object' && <div ref={copy} dangerouslySetInnerHTML={{ __html: content as string }} />}
        {typeof content === 'object' && <div ref={copy}>{content}</div>}
      </AccordionItemItemContent>
    </AccordionItemContainer>
  );
};
